import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../component/Loader";
import Select from "react-select";
import 'react-bootstrap-typeahead/css/Typeahead.css'; // Import CSS for Typeahead
import { getData, postData } from "../store/utils";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { FaImage } from "react-icons/fa";
import Modal from 'react-modal';
import { FaRegTimesCircle } from 'react-icons/fa';
import { width } from "@mui/system";


// const customStyles = {
//     content: {
//         top: "50%",
//         left: "50%",
//         right: "auto",
//         bottom: "auto",
//         marginRight: "-50%",
//         transform: "translate(-50%, -50%)",
//         overflow: "none",
//         padding: "0px",
//         minWidth: "50%",
//         maxWidth: "50%",
//     },
// };

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        overflow: "none",
        width: "400px"
    },
};

function NewItem() {
    const [isLoadingOn, setIsLoadingOn] = useState(false);
    const today = new Date().toISOString().split("T")[0];
    const [errors, setErrors] = useState({});
    const [showTopMessage, setShowTopMessage] = useState(false);
    const [brands, setBrands] = useState([]);
    const [productCategories, setProductCategories] = useState([]);
    const [productSubCategories, setProductSubCategories] = useState([]);
    const [colors, setColorData] = useState([]);
    const [sizeData, setSizeData] = useState([]);
    const [preferredVendors, setPreferredVendors] = useState([]);
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const [showModal, setShowModal] = useState(false);
    const [newSize, setNewSize] = useState('');



    const history = useHistory();

    const [formData, setFormData] = useState({
        visibleLable: false,
        type: "goods",
        productName: "",
        unit: "",
        length: "",
        width: "",
        height: "",
        dimensionUnit: "cm",
        dimensions: "",
        weight: "",
        weightUnit: "kg",
        brand: "",
        brandId: "",
        productCategoryId: "",
        productSubCategoryId: "",
        productCategory: "",
        productSubCategory: "",
        color: "",
        colorId: "",
        size: "",
        sizeId: "",
        upc: "",
        mpn: "",
        ean: "",
        isbn: "",
        sellingPrice: "",
        isSalesInformation: true,
        isPurchaseInformation: true,
        isTrackInventory: true,
        sellingAccount: 1,
        purchaseAccount: 1,
        sellingDescription: "",
        purchaseDescription: "",
        preferredVendor: "",
        preferredVendorId: "",
        inventoryAccount: "",
        inventoryValuationMethod: "",
        openingStock: "",
        openingStockRatePerUnit: "",
        reorderPoint: "",
        file: [
            {
                fileType: "",
                file: ""
            }
        ],
    });

    const [unit, setUnit] = useState([
        { label: "BOX - box", value: "BOX - box" },
        { label: "CMS - cm", value: "CMS - cm" },
        { label: "DOZ - dz", value: "DOZ - dz" },
        { label: "FTS - ft", value: "FTS - ft" },
        { label: "GMS - g", value: "GMS - g" },
        { label: "INC - in", value: "INC - in" },
        { label: "KGS - kg", value: "KGS - kg" },
        { label: "KME - km", value: "KME - km" },
        { label: "LBS - lb", value: "LBS - lb" },
        { label: "MGS - mg", value: "MGS - mg" },
        { label: "MLT - ml", value: "MLT - ml" },
        { label: "MTR - m", value: "MTR - m" },
        { label: "PCS - pcs", value: "PCS - pcs" },
    ]);

    const [sellingAccounts, setSellingAccounts] = useState([
        { value: 1, label: "Sales" },
        { value: 2, label: "Employee Advance" },
        { value: 3, label: "Prepaid Expenses" },
        { value: 4, label: "TDS Receivable" },
        { value: 5, label: "Furniture and Equipment" },
        { value: 6, label: "Advance Tax" },
        { value: 7, label: "Inventory" },
    ]);

    const [purchaseAccounts, setPurchaseAccounts] = useState([
        { value: 1, label: "Cost of Goods Sold" },
        { value: 2, label: "Employee Advance" },
        { value: 3, label: "Prepaid Expenses" },
        { value: 4, label: "TDS Receivable" },
        { value: 5, label: "Furniture and Equipment" },
        { value: 6, label: "Advance Tax" },
        { value: 7, label: "Inventory" },
    ]);

    const [inventoryAccounts, setInventoryAccounts] = useState([
        { value: 1, label: "Inventory Asset" },
        { value: 2, label: "Employee Advance" },
    ]);

    const [inventoryValuationMethods, setInventoryValuationMethods] = useState([
        { value: 1, label: "FIFO (First In First Out)" },
        { value: 2, label: "WAC (Weighted Average Costing)" }
    ]);

    const validateForm = () => {
        let newErrors = {};

        if (!formData.productName || formData.productName.trim() === "") {
            newErrors.productName = "Product name is required.";
        }

        if (!formData.unit) {
            newErrors.unit = "Unit is required.";
        }

        if (!formData.brand) {
            newErrors.brand = "Brand Name is required.";
        }

        if (!formData.sellingPrice) {
            newErrors.sellingPrice = "Selling Price is required.";
        }

        if (!formData.costPrice) {
            newErrors.costPrice = "Cost Price is required.";
        }

        if (!formData.sellingAccount) {
            newErrors.sellingAccount = "Selling Account is required.";
        }

        if (!formData.purchaseAccount) {
            newErrors.purchaseAccount = "Purchase Account is required.";
        }

        if (!formData.inventoryAccount) {
            newErrors.inventoryAccount = "Inventory Account is required.";
        }

        if (!formData.inventoryValuationMethod) {
            newErrors.inventoryValuationMethod = "Inventory Valuation Method is required.";
        }

        if (
            !formData.file ||
            !Array.isArray(formData.file) ||
            formData.file.length === 0 ||
            !formData.file[0].file
        ) {
            newErrors.file = "Please upload at least one image.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     console.log(name, value);
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         [name]: value,
    //         // [name]: type === "number" ? Number(value) : value,
    //     }));
    // }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updated = { ...prev, [name]: value };

            // If it's related to dimension, update the combined string
            if (["length", "width", "height", "dimensionUnit"].includes(name)) {
                updated.dimensions = `${updated.length}*${updated.width}*${updated.height} - ${updated.dimensionUnit}`;
            }

            // Combine only when weight or unit changes
            if (name === "weightValue" || name === "weightUnit") {
                updated.weight = `${updated.weightValue || ""}${updated.weightUnit || ""}`;
            }

            return updated;
        });
    };

    // Handle Select change (with added logic for "Add New Size")
    const handleSelectChange = (selectedOption, fieldId) => {
        console.log("selectedOption", selectedOption, fieldId);
        const nameKey = fieldId.replace("Id", "");

        // If "Add New Size" is selected, open the modal
        if (selectedOption.value === "add-new") {
            setIsOpen(true);  // Trigger the modal to add a new size
            return;  // Exit early, don't update formData yet
        }

        // Update formData for valid size selection
        if (selectedOption) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [fieldId]: selectedOption.value,
                [nameKey]: selectedOption.label,  // Set the label as well
            }));
        }
    };


    // Handle file selection
    // const handleFileChange = (event) => {
    //     console.log(event.target.files);
    //     const selectedFiles = event.target.files; // Get selected files
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         file: [...selectedFiles], // Convert FileList to array
    //     }));
    // };

    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        const maxFiles = 3;
        const maxSize = 5 * 1024 * 1024; // 5MB
    
        let newErrors = {};
    
        if (files.length > maxFiles) {
            newErrors.images = `Maximum ${maxFiles} images allowed.`;
        }
    
        const invalidSize = files.find((file) => file.size > maxSize);
        if (invalidSize) {
            newErrors.images = "Each image must be less than 5 MB.";
        }
    
        if (Object.keys(newErrors).length > 0) {
            setErrors((prev) => ({ ...prev, ...newErrors }));
            setFormData((prev) => ({ ...prev, images: [] }));
        } else {
            // Convert each file to base64
            const base64Files = await Promise.all(
                files.map((file) => convertToBase64(file))
            );

            // Save in formData (you can store fileType as well if needed)
            const fileData = base64Files.map((base64, idx) => ({
                fileType: "image",
                file: base64,
            }));

            setFormData((prev) => ({ ...prev, file: fileData }));
            setErrors((prev) => ({ ...prev, images: null }));
        }
    };
    

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1]; // 👈 remove data:image/... part
                resolve(base64String);
            };
            reader.onerror = (error) => reject(error);
        });
    };
    async function getBrands() {
        setIsLoadingOn(true);
        const tempData = await getData("users/getBrands/1");
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data.records) {
            const tempDistData = tempData.data.records.map(element => ({
                value: element.id,
                label: element.name,
            }));
            setBrands(tempDistData);
        } else {
            console.error("Error fetching User brands.");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }

    async function getProductCategory() {
        setIsLoadingOn(true);
        const tempData = await getData("users/getProductCategory/nothing");
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data.records) {
            const tempDistData = tempData.data.records.map(element => ({
                value: element.id,
                label: element.name,
            }));
            setProductCategories(tempDistData);
        } else {
            console.error("Error fetching distributor Product Type");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }
    async function getProductSubCategory(productCategoryId) {
        setIsLoadingOn(true);
        // let tempData = await getData(`users/getProductSubCategory/1?productCategoryId=${productCategoryId}`);
        let tempData = await getData(`users/getProductSubCategory/1`);
        console.log(tempData, "tempDatatempData")
        setIsLoadingOn(false);
        if (tempData.statusCode === 200 && tempData.data.records) {
            const tempDistData = tempData.data.records.map(element => ({
                value: element.id,
                label: element.name,
            }));
            setProductSubCategories(tempDistData);
        } else {
            console.error("Error fetching distributor Sub Product Type");
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            });
        }
    }

    async function ColorGetData() {
        setIsLoadingOn(true);
        const tempData = await getData("colorMaster")
        setIsLoadingOn(false);
        if (tempData.statusCode == 200) {
            const tempDistData = tempData?.data?.map((element) => {
                return { value: element.id, label: element.name };
            });
            setColorData(tempDistData);
        }
        else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors.msg || "Something went wrong!!!"
            })
        }
    }

    const SizeGetData = async () => {
        setIsLoadingOn(true);
        const tempData = await getData("sizeMaster");
        setIsLoadingOn(false);

        if (tempData.statusCode === 200) {
            let tempDistData = tempData?.data?.map((element) => ({
                value: element.id,
                label: element.name
            }));

            // ✅ Ensure selected size is also in the dropdown
            if (
                formData.sizeId &&
                !tempDistData.find((item) => item.value === formData.sizeId)
            ) {
                tempDistData = [
                    ...tempDistData,
                    {
                        value: formData.sizeId,
                        label: formData.size || "Unknown Size"
                    }
                ];
            }

            setSizeData(tempDistData);
        } else {
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    };


    async function getVendors(typeValue) {
        setIsLoadingOn(true);
        const tempData = await getData(`inventory/getVendor?vendorName=${typeValue || ''}`);
        setIsLoadingOn(false);

        if (tempData.statusCode === 200 && tempData.data.records) {
            const mappedVendors = tempData.data.records.map((vendor) => ({
                value: vendor.id,
                label: `${vendor.firstName} ${vendor.lastName} (${vendor.companyName})`, // or use vendor.vendorName if you prefer
            }));
            setPreferredVendors(mappedVendors); // <- this should be your state
        } else {
            setPreferredVendors([]); // ensure orderList is not undefined
            Swal.fire({
                title: "Error!",
                text: tempData?.data?.errors?.msg || "Something went wrong!!!"
            });
        }
    }

    // Debounced search
    useEffect(() => {
        getVendors(); // if empty string, returns all
    }, []);

    useEffect(() => {
        getBrands();
        getProductCategory();
        getProductSubCategory();
        ColorGetData();
        SizeGetData();
    }, [])

    // Open the modal to add a new size
    const openModal = () => {
        setIsOpen(true);
    };

    const handleAddSize = async () => {
        if (!newSize) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please enter a size name!'
            });
            return;
        }

        try {
            setIsLoadingOn(true);

            // Call API to add new size
            const response = await postData("sizeMaster/addSize", { sizeName: newSize });

            if (response.statusCode === 200 || response.statusCode === 201) {
                const createdSize = response.data; // e.g., { id: 5, name: "XL" }
                const newSizeOption = { value: createdSize.id, label: createdSize.name };

                // Update sizeData with the new size
                setSizeData((prev) => {
                    const updatedSizeData = [...prev, newSizeOption];
                    // Ensure the new size is selected
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        sizeId: createdSize.id,  // Set the selected size ID
                        size: createdSize.name,  // Set the selected size name (label)
                    }));
                    return updatedSizeData;
                });

                // Success alert
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Size added and selected successfully!',
                    timer: 1500,
                    showConfirmButton: false
                });
                SizeGetData()
                // Close the modal and reset input field
                setIsOpen(false);
                setNewSize('');
            } else {
                throw new Error(response?.data?.errors?.msg || "Something went wrong");
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: error.message
            });
        } finally {
            setIsLoadingOn(false);
        }
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("formData===", formData);
        // return false;
        setIsLoadingOn(true);
        // Perform form submission logic here
        if (validateForm()) {
            setIsLoadingOn(true);
            const res = await postData(`inventory/addInventoryItem`, formData);
            setIsLoadingOn(false);
            if (res.statusCode == 200) {
                setShowTopMessage(true);
                setTimeout(() => {
                    setShowTopMessage(false);
                }, 3000);
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Data inserted successfully!",
                });
                setTimeout(() => {
                    history.push('/inventory/items');
                }, 3000);

            }
        }
        // else {
        //     Swal.fire({
        //         icon: "error",
        //         title: "Error!",
        //         text: "Somthing went wrong!",
        //     });
        // }
        setIsLoadingOn(false);
    }

    const allowOnlyNumbers = (e) => {
        const { key } = e;
        const value = e.target.value;


        // If there's already a dot, check digits after decimal
        if (value.includes('.')) {
            const decimalPart = value.split('.')[1];
            if (decimalPart.length >= 2 && e.target.selectionStart > value.indexOf('.')) {
                e.preventDefault();
            }
        }

    }


    return (
        <div className="purchaseOrderSec">
            {isLoadingOn ? <Loader /> : ""}
            {/* <h4 style={{ marginBottom: 10 }}>Purchanse Order</h4> */}

            <div className="mainhd">
                <div className="d-flex justify-content-between align-items-center mainhdbrd">
                    <h4>New Item</h4>
                </div>
                <div className="formsec purchaseform newItem">
                    <form onSubmit={handleSubmit}>
                        <div className="topformsec">
                            <div className="row vendorsec">
                                <div className="col-md-6">
                                    <div className="row form-group mt-3">
                                        <div className="col-md-3">
                                            <label htmlFor="type">Type</label>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="type"
                                                    id="goods"
                                                    value="goods"
                                                    checked={formData.type === "goods"}
                                                    onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                                />
                                                <label className="form-check-label" htmlFor="goods">Goods</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="type"
                                                    id="service"
                                                    value="service"
                                                    checked={formData.type === "service"}
                                                    onChange={(e) => setFormData({ ...formData, type: e.target.value })} />

                                                <label className="form-check-label" htmlFor="service">Service</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row form-group mt-3">
                                        <div className="col-md-3">
                                            <label htmlFor="productName"><span className="required">Name*</span></label>
                                        </div>
                                        <div className="col-md-8">
                                            <input
                                                type="text"
                                                className="form-control"
                                                onChange={handleChange}
                                                name="productName"
                                                value={formData.productName}
                                            />
                                            {errors.productName && <small className="text-danger">{errors.productName}</small>}
                                        </div>
                                    </div>

                                    <div className="row form-group mt-3">
                                        <div className="col-md-3">
                                            <label htmlFor="unit"><span className="required">Unit*</span></label>
                                        </div>
                                        <div className="col-md-8 dropdown">
                                            <Select
                                                placeholder="Select or type to add"
                                                name="unit"
                                                options={unit}
                                                value={unit.find((opt) => opt.value === formData.unit)}
                                                onChange={(selectedOption) => handleSelectChange(selectedOption, "unit")}
                                            />
                                            {errors.unit && <small className="text-danger">{errors.unit}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="image-upload item-details-image redbrd">
                                        <div className="hv-centered w-100">
                                            <div><FaImage fontSize={40} /></div>
                                            <div className="font-small">
                                                <label className="text-muted drag-text">Drag image(s) here or</label>
                                                <br />
                                                <span className="text-blue cursor-pointer browseimg">Browse images</span>
                                            </div>
                                            <div>
                                                <span className="font-xs text-muted">&nbsp;You can add up to 3 images, each not exceeding 5 MB in size and 7000 X 7000 pixels resolution.</span>
                                            </div>
                                        </div>
                                        <span id="upload">
                                            <input
                                                multiple
                                                accept="image/gif,image/jpeg,image/png,image/bmp,image/jpg"
                                                className="upload ember-view form-control"
                                                name="file"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                        </span>
                                        
                                    </div>
                                    {errors.file && <small className="text-danger mr20">{errors.file}</small>}
                                </div>
                            </div>

                            <div className="itemtopsec">


                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <div className="row form-group">
                                            <div className="col-md-4">
                                                <label htmlFor="dimensions">Dimensions</label>
                                                <div>(Length X Width X Height)</div>
                                            </div>
                                            <div className="col-md-8">
                                                <div className="dimensioncontainer">
                                                    <div className="inputsec form-control">
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="length"
                                                            value={formData.length}
                                                            className="text-center"
                                                            onKeyPress={allowOnlyNumbers}
                                                        // placeholder="Length"
                                                        />
                                                        <span>X</span>
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="width"
                                                            value={formData.width}
                                                            className="text-center"
                                                            onKeyPress={allowOnlyNumbers}
                                                        // placeholder="Width"
                                                        />
                                                        <span>X</span>
                                                        <input
                                                            type="text"
                                                            onChange={handleChange}
                                                            name="height"
                                                            value={formData.height}
                                                            className="text-center"
                                                            onKeyPress={allowOnlyNumbers}
                                                        // placeholder="Height"
                                                        />
                                                    </div>
                                                    <select
                                                        className=""
                                                        name="dimensionUnit"
                                                        value={formData.dimensionUnit}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="cm">cm</option>
                                                        <option value="in">in</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group">
                                            <div className="col-md-3">
                                                <label htmlFor="weight">Weight</label>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="weight-container">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="weightValue"
                                                        value={formData.weightValue || ""}
                                                        onChange={handleChange}
                                                        onKeyPress={allowOnlyNumbers}
                                                    />
                                                    <select
                                                        className=""
                                                        name="weightUnit"
                                                        value={formData.weightUnit || "kg"}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="kg">kg</option>
                                                        <option value="g">g</option>
                                                        <option value="Ib">Ib</option>
                                                        <option value="oz">oz</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="brand">Brand</label>
                                            </div>
                                            <div className="col-md-8 dropdown">
                                                <Select
                                                    placeholder="Select Brand"
                                                    name="brandId"
                                                    options={brands}
                                                    value={brands.find((opt) => opt.value === formData.brandId)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "brandId")}
                                                />
                                                {errors.brand && <small className="text-danger">{errors.brand}</small>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="productCategory">Product Category</label>
                                            </div>
                                            <div className="col-md-8 dropdown">
                                                <Select
                                                    placeholder="Select Product Category"
                                                    name="productCategoryId"
                                                    options={productCategories}
                                                    value={productCategories.find((opt) => opt.value === formData.productCategoryId)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "productCategoryId")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="productSubCategory">Product Sub Category</label>
                                            </div>
                                            <div className="col-md-6 dropdown">
                                                <Select
                                                    placeholder="Select Product Sub Category"
                                                    name="productSubCategoryId"
                                                    options={productSubCategories}
                                                    value={productSubCategories.find((opt) => opt.value === formData.productSubCategoryId)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "productSubCategoryId")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="color">Color</label>
                                            </div>
                                            <div className="col-md-8 dropdown">
                                                <Select
                                                    placeholder="Color"
                                                    name="colorId"
                                                    options={colors}
                                                    value={colors.find((opt) => opt.value === formData.colorId)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "colorId")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="size">Size</label>
                                            </div>
                                            <div className="col-md-6 dropdown sizedropdown">
                                                {/* <Select
                                                    placeholder="Size"
                                                    name="sizeId"
                                                    options={sizes}
                                                    value={sizes.find((opt) => opt.value === formData.sizeId)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "sizeId")}
                                                />  */}
                                                <Select
                                                    placeholder="Size"
                                                    name="sizeId"
                                                    options={[{ value: 'add-new', label: '➕ Add New Size' }, ...sizeData]} // Add "Add New Size" option at top
                                                    value={sizeData.find((opt) => opt.value === formData.sizeId) || null}  // Make sure the correct size is selected
                                                    onChange={(selectedOption) => {
                                                        if (selectedOption?.value === 'add-new') {
                                                            setIsOpen(true); // Open modal when "Add New Size" is selected
                                                        } else {
                                                            handleSelectChange(selectedOption, "sizeId");
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="upc">UPC</label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="upc"
                                                    value={formData.upc}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="mpn">MPN</label>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="mpn"
                                                    value={formData.mpn}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="ean">EAN</label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="ean"
                                                    value={formData.ean}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="isbn">ISBN</label>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="isbn"
                                                    value={formData.isbn}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-md-9">
                                        <hr />
                                    </div>
                                </div>
                                <div className="row mt-3">

                                    <div className="col-md-4">
                                        <div className="form-check itemcheckbox mt-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="salesInformation"
                                                checked={formData.isSalesInformation}
                                                // onChange={(e) =>
                                                //     setFormData({
                                                //         ...formData,
                                                //         isSalesInformation: e.target.checked,
                                                //     })
                                                // }
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormData((prevFormData) => ({
                                                        ...prevFormData,
                                                        isSalesInformation: isChecked,
                                                        isTrackInventory: isChecked ? false : prevFormData.isTrackInventory, // uncheck trackInventory if checked
                                                    }));
                                                }}
                                            />
                                            <label className="form-check-label biglable" htmlFor="salesInformation">
                                                Sales Information
                                            </label>
                                        </div>
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="sellingPrice" className="sellingPrice">
                                                    <span className="required">Selling Price*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="sellingPrice"
                                                    value={formData.sellingPrice}
                                                    disabled={!formData.isSalesInformation}
                                                    onKeyPress={allowOnlyNumbers}
                                                />
                                                {errors.sellingPrice && <small className="text-danger">{errors.sellingPrice}</small>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="form-check itemcheckbox mt-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="purchaseInformation"
                                                checked={formData.isPurchaseInformation}
                                                // onChange={(e) =>
                                                //     setFormData({
                                                //         ...formData,
                                                //         isPurchaseInformation: e.target.checked,
                                                //     })
                                                // }

                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    setFormData((prevFormData) => ({
                                                        ...prevFormData,
                                                        isPurchaseInformation: isChecked,
                                                        isTrackInventory: isChecked ? false : prevFormData.isTrackInventory, // uncheck trackInventory if checked
                                                    }));
                                                }}
                                            />
                                            <label className="form-check-label biglable" htmlFor="purchaseInformation">
                                                Purchase Information
                                            </label>
                                        </div>
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="costPrice" className="labelbrd">
                                                    <span className="required">Cost Price*</span>
                                                </label>
                                            </div>
                                            <div className="col-md-6">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="costPrice"
                                                    value={formData.costPrice}
                                                    disabled={!formData.isPurchaseInformation}
                                                    onKeyPress={allowOnlyNumbers}
                                                />
                                                {errors.costPrice && <small className="text-danger">{errors.costPrice}</small>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3 ">

                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="sellingAccount" className="labelbrd">
                                                    <span className="required">Account</span>
                                                </label>
                                            </div>
                                            <div className="col-md-8 dropdown">
                                                <Select
                                                    placeholder="Select"
                                                    name="sellingAccount"
                                                    options={sellingAccounts}
                                                    value={sellingAccounts.find((opt) => opt.value === formData.sellingAccount)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "sellingAccount")}
                                                    isDisabled={!formData.isSalesInformation}
                                                />
                                                {errors.sellingAccount && <small className="text-danger">{errors.sellingAccount}</small>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="purchaseAccount" className="labelbrd"><span className="required">Account</span></label>
                                            </div>
                                            <div className="col-md-6 dropdown">
                                                <Select
                                                    placeholder="Select"
                                                    name="purchaseAccount"
                                                    options={purchaseAccounts}
                                                    value={purchaseAccounts.find((opt) => opt.value === formData.purchaseAccount)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "purchaseAccount")}
                                                    isDisabled={!formData.isPurchaseInformation}

                                                />
                                                {errors.purchaseAccount && <small className="text-danger">{errors.purchaseAccount}</small>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3">

                                    <div className="col-md-4">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-4">
                                                <label htmlFor="sellingDescription">Description</label>
                                            </div>
                                            <div className="col-md-8">
                                                <textarea
                                                    rows={2}
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="sellingDescription"
                                                    value={formData.sellingDescription}
                                                    disabled={!formData.isSalesInformation}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="purchaseDescription">Description</label>
                                            </div>
                                            <div className="col-md-6">
                                                <textarea
                                                    rows={2}
                                                    type="text"
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    name="purchaseDescription"
                                                    value={formData.purchaseDescription}
                                                    disabled={!formData.isPurchaseInformation}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-6 ps-5">
                                        <div className="row form-group mt-3">
                                            <div className="col-md-3">
                                                <label htmlFor="preferredVendor">Preferred Vendor</label>
                                            </div>
                                            <div className="col-md-6 dropdown">
                                                <Select
                                                    placeholder="Select"
                                                    name="preferredVendorId"
                                                    options={preferredVendors}
                                                    value={preferredVendors.find((opt) => opt.value === formData.preferredVendorId)}
                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "preferredVendorId")}
                                                    isDisabled={!formData.isPurchaseInformation}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {formData.isPurchaseInformation && formData.isSalesInformation && (
                                    <>
                                        <div className="row mt-4">
                                            <div className="col-md-9">
                                                <hr />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-12">
                                                <div className="form-check itemcheckbox mt-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="trackInventory"
                                                        checked={formData.isTrackInventory}
                                                        onChange={(e) =>
                                                            setFormData({
                                                                ...formData,
                                                                isTrackInventory: e.target.checked,
                                                            })
                                                        }
                                                    />
                                                    <label className="form-check-label biglable" htmlFor="trackInventory">
                                                        Track Inventory for this item
                                                    </label>
                                                </div>
                                                <p className="trackinventoryNote">You cannot enable/disable inventory tracking once you've created transactions for this item</p>
                                            </div>

                                        </div>
                                        {formData.isTrackInventory && (
                                            <>
                                                <div className="row mt-3">
                                                    <div className="col-md-4">
                                                        <div className="row form-group mt-3">
                                                            <div className="col-md-4">
                                                                <label htmlFor="inventoryAccount" className="inventoryAccount"><span className="required">Inventory Account*</span></label>
                                                            </div>
                                                            <div className="col-md-8 dropdown">
                                                                <Select
                                                                    placeholder="Select an account"
                                                                    name="inventoryAccount"
                                                                    options={inventoryAccounts}
                                                                    value={inventoryAccounts.find((opt) => opt.value === formData.inventoryAccount)}
                                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "inventoryAccount")}
                                                                />
                                                                {errors.inventoryAccount && <small className="text-danger">{errors.inventoryAccount}</small>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-5">
                                                        <div className="row form-group mt-3">
                                                            <div className="col-md-3">
                                                                <label htmlFor="inventoryValuationMethod" className="labelbrd"><span className="required">Inventory Valuation Method*</span></label>
                                                            </div>
                                                            <div className="col-md-6 dropdown">
                                                                <Select
                                                                    placeholder="Select the valuation method"
                                                                    name="inventoryValuationMethod"
                                                                    options={inventoryValuationMethods}
                                                                    value={inventoryValuationMethods.find((opt) => opt.value === formData.inventoryValuationMethod)}
                                                                    onChange={(selectedOption) => handleSelectChange(selectedOption, "inventoryValuationMethod")}

                                                                />
                                                                {errors.inventoryValuationMethod && <small className="text-danger">{errors.inventoryValuationMethod}</small>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mt-3">
                                                    <div className="col-md-4">
                                                        <div className="row form-group mt-3">
                                                            <div className="col-md-4">
                                                                <label htmlFor="openingStock" className="labelbrd">
                                                                    <span>Opening Stock</span></label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={handleChange}
                                                                    name="openingStock"
                                                                    value={formData.openingStock}
                                                                    onKeyPress={allowOnlyNumbers}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 ps-5">
                                                        <div className="row form-group mt-3">
                                                            <div className="col-md-3">
                                                                <label htmlFor="openingStockRatePerUnit" className="labelbrd">
                                                                    <span>Opening Stock <br />Rate per Unit</span>
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={handleChange}
                                                                    name="openingStockRatePerUnit"
                                                                    value={formData.openingStockRatePerUnit}
                                                                    onKeyPress={allowOnlyNumbers}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mt-3">

                                                    <div className="col-md-4">
                                                        <div className="row form-group mt-3">
                                                            <div className="col-md-4">
                                                                <label htmlFor="reorderPoint" className="labelbrd">
                                                                    <span>Reorder Point</span>

                                                                </label>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={handleChange}
                                                                    name="reorderPoint"
                                                                    value={formData.reorderPoint}
                                                                    onKeyPress={allowOnlyNumbers}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </>
                                        )}
                                    </>

                                )}


                            </div>
                        </div>
                        <div className="btnfooter">
                            <button className="btn btn-primary mt-4 mb-4" type="submit">Save & Send</button>
                            <Link to={'/inventory/items'}><button className="btn btn-secondary ms-3">Cancel</button></Link>
                        </div>
                    </form>

                    {/* Modal for adding new size */}
                    {/* {showModal && (
                        <div className="modal" style={{ display: 'block' }}>
                            <div className="modal-content">
                                <span className="close" onClick={() => setShowModal(false)}>&times;</span>
                                <h2>Add New Size</h2>
                                <input
                                    type="text"
                                    placeholder="Enter new size"
                                    value={newSize}
                                    onChange={(e) => setNewSize(e.target.value)}
                                />
                                <button onClick={handleAddSize}>Add Size</button>
                            </div>
                        </div>
                    )} */}

                    <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={() => setIsOpen(false)}
                        style={customStyles}
                        contentLabel="Example Modal"
                    >
                        <button className="modalCloseBtn" onClick={() => setIsOpen(false)}>
                            <FaRegTimesCircle />
                        </button>
                        <div>
                            <h5>Add New Size</h5>
                            <input
                                type="text"
                                placeholder="Enter new size"
                                value={newSize}
                                onChange={(e) => setNewSize(e.target.value)}
                                className="form-control"
                            />
                            <button className="btn btn-primary mt-3 text-center d-flex" onClick={handleAddSize}>Save and Select</button>
                        </div>

                    </Modal>
                </div>
            </div>
        </div>
    );
}

export default NewItem;
